module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "service-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("Služby")]), _vm._v(" "), _c('p', [_vm._v("\n          Kompletní přehled námi nabízených služeb naleznete v\n          přehledném seznamu níže. Pokud máte zájem o nějakou\n          nadstandardní službu, "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("kontaktujte nás")]), _vm._v("\n          prosím a my se Vám budeme snažit vyhovět. Jako\n          doplňkovou službu v salonu poskytujeme prodej kosmetiky a\n          potřeb pro pejsky a kočičky.\n      ")], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_c('b', [_vm._v("Bližší informace ohledně psích masáží naleznete "), _c('router-link', {
    attrs: {
      "to": "/massage"
    }
  }, [_vm._v("zde")]), _vm._v(".")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Ceny pro uvedené služby jsou pouze orientační.")])])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("U problematičtějších pejsků vítáme přítomnost páníčka či paničky po dobu procedury.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "modernTable",
    attrs: {
      "cellspacing": "1",
      "cellpadding": "1",
      "border": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Masáže psů")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Cena")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Malá plemena (do 30 cm výšky)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("doba trvání 30 min.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Střední plemena (30 - 45 cm výšky)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("doba trvání 45 min.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("300 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Velká plemena(45 cm a výše)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("doba trvání 60 min.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("400 Kč")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "modernTable",
    attrs: {
      "cellspacing": "1",
      "cellpadding": "1",
      "border": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Druh plemene")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Koupání")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Stříhání "), _c('b', [_vm._v("*")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Trimování "), _c('b', [_vm._v("*")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Pudl toy")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("500 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Pudl trpasličí")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pudl střední")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("250 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("650 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pudl královský")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("400 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kokr anglický")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("300 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("650 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1100 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kokr americký")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("300 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("650 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1100 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bišonek")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Boloňský psík")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maltézský psík")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Knírač malý")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Knírač střední")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("250 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("650 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1100 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Knírač velký")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("400 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1300 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jorkšírský teriér")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("500 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Teriér malý")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Teriér střední")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("250 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("650 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1100 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Teriér velký")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("400 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1300 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shih-tzu")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("West teriér")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("900 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jezevčík")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("500 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kříženec malý")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("200 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("600 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kříženec střední")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("250 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("650 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kříženec velký")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("400 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1300 Kč")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ostatní velká plemena")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("400 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("800 Kč")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1300 Kč")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("*Stříhání drápků a čištění očí a uší jsou již zahrnuty v ceně stříhání.")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("*Stříhání a trimování pouze společně s koupáním.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "modernTable withHeader",
    attrs: {
      "cellspacing": "1",
      "cellpadding": "1",
      "border": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Služba")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Cena")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Popis")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Rozčesávání zplst. srsti")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("300 Kč / hod.")]), _vm._v(" "), _c('td', [_vm._v("Vyžaduje předchozí domluvu")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Stříhání zplst. srsti")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("300 Kč")]), _vm._v(" "), _c('td', [_vm._v("Účtováno dodatečně ke stříhání")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Přítomnost blech u psa")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("150 - 300 Kč")]), _vm._v(" "), _c('td', [_vm._v("Poplatek dezinfekce a odblešení")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Odstranění klíšťat")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("30 Kč / kus")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Čištění očí")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("50 Kč")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Čištění uší")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("50 Kč")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Stříhání drápků")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("100 Kč")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Depilace ušního zvukovodu")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("100 Kč")]), _vm._v(" "), _c('td')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53347a4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ServiceView.vue
// module id = 77
// module chunks = 0